'use client'

import { WalletProgressAlert } from '@repo/shared'
import { Col, Row } from '@repo/ui/components'
import { DashboardEstimatedAssetsSkeleton } from './dashboard.estimated-assets.skeleton'
import { DashboardMarketSummary } from './dashboard.market-summary'
import { DashboardSquareToken } from './dashboard.square-token'

import dynamic from 'next/dynamic'
import { DashboardSquareTokenWaysSkeleton } from './dashboard.square-token-ways.skeleton'

const DashboardEstimated = dynamic(
  async () => (await import('./dashboard.estimated')).DashboardEstimated,
  {
    ssr: false,
    loading: () => (
      <div className='relative min-h-[0] sm:min-h-[88px] sm:max-h-[88px] mb-0 sm:mb-4xl'>
        <DashboardEstimatedAssetsSkeleton isDesktop />
      </div>
    ),
  },
)

// const DashboardCarousel = dynamic(
//   async () => (await import('./dashboard.carousel')).DashboardCarousel,
//   {
//     ssr: false,
//     loading: () => (
//       <BannerCarouselLoading className='-mt-xs sm:mt-4xl mb-md sm:mb-2xl !min-h-[161px] sm:!min-h-[155px] w-auto -mx-md sm:-mx-0' />
//     ),
//   },
// )

const DashboardSquareTokenWays = dynamic(
  async () =>
    (await import('./dashboard.square-token-ways')).DashboardSquareTokenWays,
  {
    ssr: false,
    loading: () => <DashboardSquareTokenWaysSkeleton />,
  },
)

export const DashboardContainer = () => {
  return (
    <>
      <DashboardEstimated />
      {/* <DashboardCarousel /> */}

      <Col className='gap-3xl w-full mb-[350px] sm:mb-[200px] min-h-[500px]'>
        <WalletProgressAlert />
        <DashboardMarketSummary />
        <Row className='gap-0 sm:gap-xl items-stretch flex-wrap'>
          <Col className='w-full md:w-5/12'>
            <DashboardSquareToken />
          </Col>
          <Col className='w-full md:flex-1'>
            <DashboardSquareTokenWays />
          </Col>
        </Row>
      </Col>
    </>
  )
}
